module.exports = {
  MAX_VALUE: 25000,
  MICRODEPOSIT_MAX_VALUE: 0.01
};
